import "./AffiliateContent.scss";

export default function AffiliateContent() {
  return (
  <main className="affiliate-content">
    <section className={"one"}>
      <div className="content">
        <div className={"flex reverse"}>
          <h3 className={"mobile-only"}>Affiliate Program</h3>
          <h1 className={"mobile-only"}>Earn money when you refer people to MustHaveMenus!</h1>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/affiliate/affiliate-hero.png"} alt={"Refer for money"} />
          </div>
          <div className={"half"}>
            <h3 className={"desktop-only"}>Affiliate Program</h3>
            <h1 className={"desktop-only"}>Earn money when you refer people to MustHaveMenus!</h1>
            <p>
              For over a decade, MustHaveMenus has provided restaurants with a single source for their design, marketing and printing needs. With the largest collection of menu templates in the world and <b>The Best Menu Maker App*</b>, MustHaveMenus makes it easy for anyone to design, print, and share professional-looking restaurant collateral.
            </p>
            <a href={"/content/affiliate/form"} className={"ant-btn ant-btn-primary ant-btn-lg"}>Become an Affiliate</a>
            <div className={"footnote"}>*Small Business Trends, Jan '22</div>
          </div>
        </div>
      </div>
    </section>

    <section className={"two"}>
      <div className="content">
        <div className={"flex"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/affiliate/affiliate-hero2.png"} alt={"Marketing solutions"} />
          </div>
          <div className={"half"}>
            <h3>We're working to provide marketing solutions to over 14,000 restaurants across the globe, with dazzling design, professional print products, and top tier customer service.</h3>
            <p>
              Collaboration is a key component in the industry, and we love working with like-minded businesses to help restaurants succeed.
            </p>
            <p>
              As an affiliate of MustHaveMenus, <b>you can earn 10% recurring revenue for every customer you sign up</b> whether they print or purchase a subscription.
            </p>
            <a href={"/content/affiliate/form"} className={"ant-btn ant-btn-primary ant-btn-lg"}>Become an Affiliate</a>
          </div>
        </div>
      </div>
    </section>
  </main>
  )
}
